module.exports = __webpack_public_path__ + "static/media/spread.9956182e.png";